import { Navigate, Outlet } from "react-router"

import { PRODUCTS_HOME_PATH } from "@/lib/post-auth-landing"
import { canReadDirectory } from "@/lib/workspace-role"

export function RequireDirectoryAccess() {
  if (!canReadDirectory()) return <Navigate to={PRODUCTS_HOME_PATH} replace />
  return <Outlet />
}
